export enum DraftInvoiceStatusType {
  Rejected = 'rejected',
  Draft = 'draft',
  Approve = 'approve'
}
